module.exports = __webpack_public_path__ + "img/Plan-de-travail 42@2x-100.6f110835.jpg";